import { Button } from '@lmc/ui-kit'
import { ReactNode } from 'react'

type DownloadButtonProps = {
  fileUrl: string
  fileName: string
  children: ReactNode
  testId?: string
}

const DownloadButton = ({
  fileUrl,
  fileName,
  children,
  testId,
}: DownloadButtonProps) => {
  const handleDownload = () => {
    const link = document.createElement('a')
    link.href = fileUrl
    link.target = '_blank'
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  return (
    <Button
      variant="text"
      onClick={handleDownload}
      data-testid={testId ? `${testId}-download-button` : 'download-button'}
    >
      {children}
    </Button>
  )
}

export default DownloadButton
